import { useClub } from '@/features/settings/hooks/use-club'
import { usePreviewSession } from './use-preview-session'

/**
 * Resolves the club name of the active preview session, or null when no
 * preview is active. Lives in preview-session/hooks so the welcome-dialog
 * component can show "Bienvenido a {clubName}" without `preview-session/
 * components` reaching directly into `settings/hooks` — the boundary
 * rule allows hooks-to-hooks crosscuts but not components-to-cross-feature
 * hooks. Same shape as `useClub`: returns the trimmed name or null.
 */
export function usePreviewClubName(): string | null {
  const session = usePreviewSession()
  const clubQuery = useClub(session.clubId)
  return clubQuery.data?.name?.trim() || null
}
